import {state} from "@/state";
import {io} from "socket.io-client";
import {watch} from "vue";
import router from "@/router";
import eventBus from "@/eventBus";

export default {
    install() {
        state.plugins.socket = {
            io: undefined,
            data: {
                joinedCommunityId: undefined
            },
            connect() {
                if (this.io) {
                    this.io.disconnect();
                    this.io = undefined;
                }
                this.io = io("https://" + location.host + "/backend", { withCredentials: true, path: "/beacon/socket/" });
                this.io.on("vactar:event", data => {
                    eventBus.emit("socket:event", data);
                });
                this.io.on("connect", () => {
                    this.checkCommunityJoin(router.currentRoute.value);
                });
            },
            disconnect() {
                if (this.io && this.io.connected) this.io.disconnect();
                this.io = undefined;
            },
            emit(event, data) {
                if (this.io && this.io.connected) {
                    this.io.emit(event, data);
                } else {
                    console.error("Cannot emit " + event + " to socket (not connected).")
                }
            },
            isConnected() {
                return this.io && this.io.connected;
            },
            checkCommunityJoin(route) {
                if (!this.isConnected()) return;
                if (!route.params.communityId || state.plugins.socket.data.joinedCommunityId && route.params.communityId !== state.plugins.socket.data.joinedCommunityId) {
                    state.plugins.socket.emit("leave:community");
                    state.plugins.socket.data.joinedCommunityId = undefined;
                }
                if (route.params.communityId && (!state.plugins.socket.data.joinedCommunityId || state.plugins.socket.data.joinedCommunityId !== route.params.communityId)) {
                    state.plugins.socket.emit("join:community", {
                        communityId: route.params.communityId
                    });
                    state.plugins.socket.data.joinedCommunityId = route.params.communityId;
                }
            }
        };
        eventBus.on("login", () => {
            state.plugins.socket.connect();
        });
        eventBus.on("logout", () => {
            state.plugins.socket.disconnect();
        });
        watch(router.currentRoute, route => {
            state.plugins.socket.checkCommunityJoin(route);
        });
    }
}
